module.exports = __webpack_public_path__ + "static/media/phagans-all-logo_2.13ac99b7.png";